import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedAdminRoute = ({ isAuthenticated, children }) => {
    // ✅ Wait for App.js to finish checking auth state
    // Don't check cookie here to avoid render loops
    if (isAuthenticated === null) {
        return <h2>Loading...</h2>;
    }

    // ✅ Once App.js has determined auth state, use it directly
    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedAdminRoute;
